module.exports = __webpack_public_path__ + "static/media/image15.86608ec0.jpg";